import * as React from "react";
import { ClientDetails } from "../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { GenderMap } from "../../../../../Shared/Entities/Maps/GenderMap";
import { TitleMap } from "../../../../../Shared/Entities/Maps/TitleMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { dateParser } from "../../Common/Review/ReviewParser";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProductOverviewSippPensionInformationAction } from "../../PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewSippPensionInformationAction";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { IJsonDate } from "../../../../../../Wrap/System/IJsonDate";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { ProductOverviewProductInformationAction } from "../../PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewProductInformationAction";
import { Permission } from "../../../../../Shared/Permission/Permission";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { RetirementAge } from "../../Common/PaymentsIn/SIPP/RetirementAge";
import { PlannedRetirement } from "../../../../../../Wrap/Constants/Enums/PlannedRetirement";
import { addYears } from "../../../../../../react-core/utils/date";
import { WhatIfAction } from "../Action/WhatIfAction";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { InstructionAdditionalDataItemClient } from "../../../../../../Wrap/Api/Instruction/InstructionAdditionalDataItem";
import { InstructionAdditionalDataItem } from "../../../../../../Wrap/Models/Models/Instructions/InstructionAdditionalDataItem";
interface IClientDetailsForWhatIfProps extends IProcessComponentProps {
    extraInfo: WhatIfToolDetailModel;
}

interface IClientDetailsForWhatIfState {
    PlannedRetirement: PlannedRetirement;
    PlannedRetirementDate?: IJsonDate;
    showEditRetirementDateLightbox: boolean;
    UpdatedPlannedRetirementDate?: IJsonDate;
}

export class ClientDetailsForWhatIf extends ProcessComponent<
    IClientDetailsForWhatIfProps,
    IClientDetailsForWhatIfState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            PlannedRetirement: PlannedRetirement.Age,
            PlannedRetirementDate: null,
            UpdatedPlannedRetirementDate: null,
            showEditRetirementDateLightbox: false,
        };
    }

    componentDidMount() {
        if (this.props.extraInfo?.CurrentHoldings[0]?.WrapperType == SubAccountType.Npr) {
            ProductOverviewSippPensionInformationAction.get(getQueryParameters()["subaccounthierarchyid"], (data) => {
                this.setState({ PlannedRetirementDate: data?.RetirementDate });
            });
            var instructionId = HierarchyIdHelper.generateHierarchyId(getQueryParameters()["id"]).entityId;
            WhatIfAction.getInstructionAdditionalDataItem(instructionId,  (data) => {
                var updatedPlannedRetirementDate = data.find(x => x.InstructionAdditionalDataItemTypeId == 'RetirementDate')?.Value
                if (updatedPlannedRetirementDate) {
                    this.setState({UpdatedPlannedRetirementDate: JsonDateParser.toJsonDateNoOffset(new Date(updatedPlannedRetirementDate))})
                }
            });
        }
    }

    saveRetirementDate() {
        if ((this.props.extraInfo?.PrimaryClientDetails?.DateOfBirth
                ? addYears(JsonDateParser.toDateNoOffset(this.props.extraInfo?.PrimaryClientDetails?.DateOfBirth), 55)
                : new Date()) <= JsonDateParser.toDateNoOffset(this.state.PlannedRetirementDate))
        {
            var instructionId = HierarchyIdHelper.generateHierarchyId(getQueryParameters()["id"]).entityId;
            var instructionAdditionalDataItem: InstructionAdditionalDataItem = {
                InstructionAdditionalDataItemTypeId: 'RetirementDate',
                Value: JsonDateParser.getFormatDate(this.state.UpdatedPlannedRetirementDate, "dd-MM-yyyy")
            }
            WhatIfAction.putInstructionAdditionalDataItem(instructionId, [instructionAdditionalDataItem], () => {
                this.setState({ showEditRetirementDateLightbox: false });
            });
        }
    }

    private config = (data: ClientDetails) => [
        {
            title: "Title",
            data: TitleMap.getString(data?.Title),
        },
        {
            title: "First name(s)",
            data: data?.FirstName,
        },
        {
            title: "Surname",
            data: data?.LastName,
        },
        {
            title: "Gender",
            data: GenderMap.getString(data?.Gender),
        },
        {
            title: "Date of birth",
            data: dateParser(data?.DateOfBirth),
        },
        {
            title: "Retirement age",
            data: (
                <>
                    {JsonDateParser.toDate(this.state.UpdatedPlannedRetirementDate ?? this.state.PlannedRetirementDate)?.getFullYear() -
                        JsonDateParser.toDate(this.props.extraInfo?.PrimaryClientDetails?.DateOfBirth)?.getFullYear()}
                    (
                    {JsonDateParser.getFormatDate(
                        JsonDateParser.toDate(this.state.UpdatedPlannedRetirementDate ?? this.state.PlannedRetirementDate),
                        "dd/MM/yyyy"
                    )}
                    )
                    <Permission userClaim={UserClaim.AdviserPortalPortfolioViewRolesReadWrite}>
                        <button
                            type="button"
                            className="edit-circle-icon-button label-sr-only"
                            title="Edit"
                            onClick={() => {
                                this.setState({ showEditRetirementDateLightbox: true });
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Edit Retirement Date</span>
                        </button>
                    </Permission>
                </>
            ),
        },
    ];

    public render(): JSX.Element {
        return (
            <>
                {this.props.extraInfo?.PrimaryClientDetails && (
                    <>
                        <h2>Client details</h2>
                        <Typography type="wider" config={this.config(this.props.extraInfo?.PrimaryClientDetails)} />
                    </>
                )}
                {this.props.extraInfo?.SecondaryClientDetails && (
                    <>
                        <h2>Client details</h2>
                        <Typography type="wider" config={this.config(this.props.extraInfo?.SecondaryClientDetails)} />
                    </>
                )}

                {this.state.showEditRetirementDateLightbox && (
                    <Lightbox
                        cssWrapper="is-default-lightbox"
                        show={this.state.showEditRetirementDateLightbox}
                        onClose={() => this.setState({ showEditRetirementDateLightbox: false })}
                        title="Edit Retirement Age / Date"
                    >
                        <RetirementAge
                            clientInfo={{ DateOfBirth: this.props.extraInfo?.PrimaryClientDetails?.DateOfBirth }}
                            data={{
                                PlannedRetirement: this.state.PlannedRetirement,
                                PlannedRetirementDate: this.state.UpdatedPlannedRetirementDate,
                            }}
                            onChange={(v) => {
                                if (v.PlannedRetirement != null) {
                                    this.setState({ PlannedRetirement: v.PlannedRetirement });
                                }
                                if (v.PlannedRetirementDate != null) {
                                    this.setState({ UpdatedPlannedRetirementDate: v.PlannedRetirementDate });
                                }
                            }}
                            onRef={() => {}}
                        />

                        <div className="row mt-20">
                            <div className="col-auto">
                                <button
                                    className="button mr-20"
                                    onClick={() => this.setState({ showEditRetirementDateLightbox: false })}
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-auto">
                                <button className="button" onClick={() => this.saveRetirementDate()}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </Lightbox>
                )}
            </>
        );
    }
}
